import clsx from 'clsx'
import React, { ReactNode } from 'react'

import useStyles from './formInputcontainer.styles'

interface Props {
  children: ReactNode
  asColumn?: boolean
}

const FormInputContainer: React.FC<Props> = ({ children, asColumn }) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.formInputContainerRoot, {
        [classes.formInputContainerAsColumn]: Boolean(asColumn),
      })}
    >
      {children}
    </div>
  )
}

export default FormInputContainer
